module.exports = __webpack_public_path__ + "img/yellow-card-symbol.cbacc8ca.svg";